const options = {
  5: "bg-rose-50/5",
  10: "bg-rose-50/10",
  25: "bg-rose-50/25",
  50: "bg-rose-50/50",
  75: "bg-rose-50/75",
  90: "bg-rose-50/90",
  100: "bg-rose-50",
};

const from = {
  5: "from-rose-50/5",
  10: "from-rose-50/10",
  25: "from-rose-50/25",
  50: "from-rose-50/50",
  75: "from-rose-50/75",
  90: "from-rose-50/90",
  100: "from-rose-50",
};

export default function getBackgroundRose50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
